import React, { useContext } from 'react';
import NostoCart from './Cart';
import ChannelContext from '../ChannelContext';
import get from 'lodash.get';
const FlightNostoCart = ({ cart }) => {
    const { selectedChannel } = useContext(ChannelContext);
    if (get(selectedChannel, 'settings.nostoAccountId') && cart) {
        const data = {
            lineItems: cart.items.map(item => {
                return {
                    id: item.id,
                    productId: item.product.id,
                    quantity: item.quantity,
                    name: item.product.name,
                    price: item.total.incVat,
                    currencyCode: selectedChannel.currency.format.code
                };
            })
        };
        return React.createElement(NostoCart, { data: data, promise: null });
    }
    else
        return null;
};
export default FlightNostoCart;
//# sourceMappingURL=FlightNostoCart.js.map